/* ==========================================================================
   TodoTecno Global - Visual currency converter
   Shop is priced in USD (PayPal charges in USD). This only changes what the
   visitor SEES. Prices are marked up with <span class="money" data-cents="...">
   where data-cents is the amount in USD cents.
   ========================================================================== */
(function () {
  var CFG = window.TTG_CURRENCY || {};
  if (!CFG.enabled) return;

  var SUPPORTED = ['USD', 'EUR', 'MXN'];
  var FORMATS = {
    USD: { symbol: '$', code: 'USD' },
    EUR: { symbol: '€', code: 'EUR' },
    MXN: { symbol: 'MX$', code: 'MXN' }
  };
  var EUROPE = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','NO','IS','LI','CH'];
  var LS_CUR = 'ttg-currency';
  var LS_GEO = 'ttg-currency-geo';
  var LS_RATES = 'ttg-currency-rates';
  var RATES_TTL = 12 * 60 * 60 * 1000;   // 12 h
  var GEO_TTL = 30 * 24 * 60 * 60 * 1000; // 30 d

  // Manual rates from theme settings, meaning: 1 USD = rate[X] units of X
  var rates = { USD: 1, EUR: toNum(CFG.rates && CFG.rates.EUR, 0.92), MXN: toNum(CFG.rates && CFG.rates.MXN, 18.5) };
  var current = 'USD';

  function toNum(v, fallback) {
    var n = parseFloat(String(v == null ? '' : v).replace(',', '.').replace(/[^0-9.\-]/g, ''));
    return isFinite(n) && n > 0 ? n : fallback;
  }
  function readLS(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function writeLS(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function formatAmount(value, cur) {
    var rounding = CFG.rounding || 'none';
    var decimals = 2;
    if (rounding === 'integer') { value = Math.round(value); decimals = 0; }
    else if (rounding === 'charm') { value = Math.max(0, Math.ceil(value) - 0.01); decimals = 2; }
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var num = parts.join(parts[1] != null ? '.' : '');
    return FORMATS[cur].symbol + num;
  }

  function convertAll() {
    var nodes = document.querySelectorAll('.money[data-cents]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cents = parseInt(el.getAttribute('data-cents'), 10);
      if (isNaN(cents)) continue;
      if (!el.hasAttribute('data-usd-html')) el.setAttribute('data-usd-html', el.innerHTML);
      if (current === 'USD') {
        el.innerHTML = el.getAttribute('data-usd-html');
      } else {
        var usd = cents / 100;
        el.textContent = formatAmount(usd * rates[current], current);
      }
    }
    document.documentElement.setAttribute('data-currency', current);
    var notices = document.querySelectorAll('.js-currency-notice');
    for (var n = 0; n < notices.length; n++) notices[n].hidden = (current === 'USD') || !CFG.notice;
    syncSelectors();
  }

  function setCurrency(cur, persist) {
    cur = (cur || '').toUpperCase();
    if (SUPPORTED.indexOf(cur) === -1) return;
    current = cur;
    if (persist) writeLS(LS_CUR, cur);
    convertAll();
  }

  function syncSelectors() {
    var sels = document.querySelectorAll('.js-currency-selector');
    for (var i = 0; i < sels.length; i++) if (sels[i].value !== current) sels[i].value = current;
  }

  function bindSelectors() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('js-currency-selector')) setCurrency(t.value, true);
    });
  }

  function fetchRates() {
    if (!CFG.autoRates) return;
    var cached = null;
    try { cached = JSON.parse(readLS(LS_RATES) || 'null'); } catch (e) {}
    if (cached && cached.t && (Date.now() - cached.t) < RATES_TTL && cached.rates) {
      rates.EUR = toNum(cached.rates.EUR, rates.EUR);
      rates.MXN = toNum(cached.rates.MXN, rates.MXN);
      convertAll();
      return;
    }
    fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || !d.rates) return;
        if (d.rates.EUR) rates.EUR = d.rates.EUR;
        if (d.rates.MXN) rates.MXN = d.rates.MXN;
        writeLS(LS_RATES, JSON.stringify({ t: Date.now(), rates: { EUR: rates.EUR, MXN: rates.MXN } }));
        convertAll();
      })
      .catch(function () {});
  }

  function countryToCurrency(cc) {
    cc = (cc || '').toUpperCase();
    if (cc === 'MX') return 'MXN';
    if (EUROPE.indexOf(cc) !== -1) return 'EUR';
    return 'USD';
  }

  function autodetect() {
    if (!CFG.autodetect) { setCurrency('USD', false); return; }
    // Hint from Liquid (Shopify IP geolocation) to avoid a flash for MX/AR.
    var hint = countryToCurrency(CFG.geoCountry);
    if (hint !== 'USD') setCurrency(hint, false);

    var geo = null;
    try { geo = JSON.parse(readLS(LS_GEO) || 'null'); } catch (e) {}
    if (geo && geo.t && (Date.now() - geo.t) < GEO_TTL && geo.cur) {
      setCurrency(geo.cur, false);
      return;
    }
    fetch('https://get.geojs.io/v1/ip/country.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cur = countryToCurrency(d && d.country);
        writeLS(LS_GEO, JSON.stringify({ t: Date.now(), cur: cur }));
        setCurrency(cur, false);
      })
      .catch(function () {});
  }

  function init() {
    bindSelectors();
    var saved = readLS(LS_CUR);
    if (saved && SUPPORTED.indexOf(saved) !== -1) {
      setCurrency(saved, false);   // explicit visitor choice wins
    } else {
      convertAll();
      autodetect();
    }
    fetchRates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
